import $ from 'jquery';

// The confirmation provides cart actions, so WooCommerce's extra cart link is redundant.
$(document.body).on('wc_cart_button_updated.ravessa', (event, button) => {
    $(button).next('a.added_to_cart.wc-forward').remove();
});

const isAddToCartButton = (formData) => {
    let isValid = false;

    $.each(formData, (index, data) => {
        if (data.name === 'add-to-cart') {
            isValid = true;
        }
    });

    return isValid;
};

const addToCart = (addToCartButton, formData) => {
    if (addToCartButton.data('cart-pending')) return;
    addToCartButton.data('cart-pending', true).addClass('is-adding').attr('aria-busy', 'true');
    const host = addToCartButton.closest('form.cart').length
        ? addToCartButton.closest('form.cart')
        : addToCartButton;
    host.next('.CartAddError').remove();
    const showError = (message) => {
        const text = $('<div>')
            .html($.parseHTML(message || '', document, false))
            .text()
            .trim();
        $('<p class="CartAddError" role="alert">')
            .text(text || 'Nie udało się dodać produktu. Sprawdź połączenie i spróbuj ponownie.')
            .insertAfter(host);
    };
    $(document.body).trigger('adding_to_cart', [addToCartButton, formData]);

    $.ajax({
        type: 'POST',
        dataType: 'json',
        timeout: 20000,
        data: $.param(formData),
        url: jsData.ajaxUrl,
        success: (response) => {
            if (!response || response.error || response.success === false || !response.fragments) {
                showError(
                    typeof response?.error === 'string' ? response.error : response?.data?.message,
                );
                return;
            }
            $(document.body).trigger('added_to_cart', [
                response.fragments,
                response.cart_hash,
                addToCartButton,
            ]);
            $(document.body).trigger('wc_fragment_refresh');
        },
        error: () => showError(),
        complete: () =>
            addToCartButton
                .removeData('cart-pending')
                .removeClass('is-adding')
                .attr('aria-busy', 'false'),
    });
};

$(document).on('submit', 'form.cart', (ev) => {
    const form = $(ev.target);
    const addToCartBtn = form.find('button[type="submit"]');

    const formData = form.serializeArray();
    if (
        addToCartBtn.attr('name') &&
        addToCartBtn.attr('name') === 'add-to-cart' &&
        addToCartBtn.attr('value')
    ) {
        formData.push({ name: 'add-to-cart', value: addToCartBtn.attr('value') });
    }

    if (isAddToCartButton(formData)) {
        ev.preventDefault();
    } else {
        return;
    }

    formData.push({ name: 'action', value: 'verenza_add_to_cart' });

    addToCart(addToCartBtn, formData);
});

$(document).on('click', '.ajax_add_to_cart', (ev) => {
    // WooCommerce handles standard loop buttons on document.body before this fallback.
    if (ev.isDefaultPrevented()) return;
    ev.preventDefault();

    addToCart($(ev.currentTarget), [
        {
            name: 'quantity',
            value: $(ev.currentTarget).attr('data-quantity'),
        },
        {
            name: 'action',
            value: 'verenza_add_to_cart',
        },
        {
            name: 'add-to-cart',
            value: $(ev.currentTarget).attr('data-product_id'),
        },
    ]);
});
